import PropTypes from "prop-types";
import TableSortLabel from "@mui/material/TableSortLabel";

const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});

const isBlankSortValue = (value) => value === null || value === undefined || value === "";

export const epcSortValue = (revenue, breakdown, stats = {}) => {
  const clicks = Number(breakdown?.overall?.clicks ?? stats.total);
  const totalRevenue = Number(revenue);

  return Number.isFinite(clicks) && clicks > 0 && Number.isFinite(totalRevenue)
    ? totalRevenue / clicks
    : null;
};

export const sortTableRows = (rows, sortConfig, valueForKey) => {
  if (!sortConfig?.key) return rows;

  return rows
    .map((row, index) => ({ row, index }))
    .sort((first, second) => {
      const firstValue = valueForKey(first.row, sortConfig.key);
      const secondValue = valueForKey(second.row, sortConfig.key);
      const firstBlank = isBlankSortValue(firstValue);
      const secondBlank = isBlankSortValue(secondValue);

      if (firstBlank || secondBlank) {
        if (firstBlank && secondBlank) return first.index - second.index;
        return firstBlank ? 1 : -1;
      }

      const firstNumber = typeof firstValue === "number" ? firstValue : Number.NaN;
      const secondNumber = typeof secondValue === "number" ? secondValue : Number.NaN;
      const comparison = Number.isFinite(firstNumber) && Number.isFinite(secondNumber)
        ? firstNumber - secondNumber
        : collator.compare(String(firstValue), String(secondValue));

      if (comparison === 0) return first.index - second.index;
      return sortConfig.direction === "desc" ? -comparison : comparison;
    })
    .map(({ row }) => row);
};

function ProjectTableSortLabel({ label, sortKey, sortConfig, onSort }) {
  const active = sortConfig.key === sortKey;

  return (
    <TableSortLabel
      active={active}
      direction={active ? sortConfig.direction : "asc"}
      onClick={() => onSort(sortKey)}
      sx={{
        color: "inherit !important",
        fontSize: "inherit",
        lineHeight: "inherit",
        "& .MuiTableSortLabel-icon": {
          fontSize: "14px",
          mx: 0.15,
        },
      }}
    >
      {label}
    </TableSortLabel>
  );
}

ProjectTableSortLabel.propTypes = {
  label: PropTypes.node.isRequired,
  sortKey: PropTypes.string.isRequired,
  sortConfig: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.oneOf(["asc", "desc"]),
  }).isRequired,
  onSort: PropTypes.func.isRequired,
};

export default ProjectTableSortLabel;
